import axios from "axios";
import Vue from "vue";
import Cookies from "js-cookie";
import { Notifications } from "../notification";
import * as Vars from "../logic/Vars";
import updateAPIEndpoint from "../logic/Vars";

export class User{

  /**
   * Signs in the user according to the given credentials.
   * @param {string} email The email of the console user.
   * @param {string} password The password of the console user.
   */
  static async login(email, password){
    return new Promise((resolve, reject) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/auth/login.php",
        method: 'POST',
        data: {
          email: email,
          password: password
        }
      }).then(function(response){
        resolve(response.data);
      }).catch(function(response) {
        reject(response);
      });
    });
  }

  /**
   * Returns true if the user is signed in and false if not or the token is not valid
   */
  static async isSignedIn(){
    var host = localStorage.getItem("api_host");
    if (host == undefined) {
      this.host = Vue.prototype.$API_ENDPOINT;
    } else {
      this.host = host;
      updateAPIEndpoint(this.host);
      Vue.prototype.$API_ENDPOINT = this.host;
    }

    return new Promise((resolve, reject) => {
      var token = Cookies.get("_console_token");

      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/auth/check.php",
        method: "GET",
        params: {
          _console_token: token
        }
      }).then(function(response){
        resolve(response.data.status === 200); //Return if the session is valid
      }).catch((e) => {
        reject(e);
      });
    });
  }

  /**
   * Does the whole logout process (clientside-only)
   * @param {object} instance The view instance (this), for the redirect.
   */
  static async logoutAndRedirect(instance){
    var token = Cookies.get("_console_token");

    //Remove the session also in the backend safely
    var response = await axios({
      url: Vars.API_ENDPOINT + "/console_api/v1/auth/login.php",
      method: "DELETE",
      data: {
        _console_token: token
      }
    });
    if (response.status === 200) {
      Cookies.remove("_console_token");
      instance.$router.replace("login");
      Notifications.show("Logout was successfully");
    } else {
      Notifications.show("There was an error while logout.");
    }
  }

  /**
   * Removes all session tokens from the currently logged in user.
   */
  static async removeAllSessions(instance) {
    var token = Cookies.get("_console_token");

    var response = await axios({
      url: Vars.API_ENDPOINT + "/console_api/v1/auth/login.php",
      method: "DELETE",
      data: {
        _console_token: token,
        function: "delete_all"
      }
    });
    if (response.status === 200) {
      Cookies.remove("_console_token");
      instance.$router.replace("login");
      Notifications.show("All session tokens were deleted.");
    } else {
      Notifications.show("There was an error while deleting all session tokens.");
    }
  }
}
